import React, { useContext } from 'react';
import {
  ProductPrice,
} from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';
import MerchPromoMessage from './MerchPromoMessage';

export default function ProductPriceSection() {
  const ProductPageState = useContext(ProductPageContext);

  const {
    collectionData,
  } = ProductPageState;

  if (!collectionData || !collectionData.activeProduct) {
    return null;
  }

  const {
    brand,
    prices,
  } = collectionData.activeProduct;

  const hasMemberPrice = collectionData.hasMemberPricingEnabled && prices.member?.description;

  return (
    <div className="product-price-container" data-product-brand={brand}>
      <ProductPrice
        brand={brand}
        discountPrice={prices.list.discountPrice}
        discountText={prices.list.discountText}
        originalPrice={prices.list.originalPrice}
        description={prices.list.description}
        variant={prices.list.variant}
      />
      {hasMemberPrice && (
        <ProductPrice
          brand={brand}
          discountPrice=""
          discountText={prices.member.discountText}
          originalPrice={prices.member.originalPrice}
          description={prices.member.description}
          variant={prices.member.variant}
        />
      )}
      {collectionData?.hasGermanTax && (
      <div data-product-brand={brand === 'gh' ? 'hol' : brand} className={`product-price-german-tax ${(hasMemberPrice || prices.list.discountPrice) ? 'product-price-german-tax-discounted' : ''}`}>
        {ProductPageState?.tmntData?.germanIncludeTax?.value}
      </div>
      )}
      <MerchPromoMessage />
    </div>
  );
}
